export enum ERoutes {
  SignIn = '/entrar',
  SignUpPresentation = '/cadastrar',
  SignUpForm = '/cadastrar/criar',
  SignUpConfirmEmail = '/cadastrar/confirmar-email',
  ConfirmEmail = '/confirmar-email',
  RecoverPassword = '/recuperar-senha',
  NewPassword = '/nova-senha',
  Home = '/',
  Dashboard = '/dashboard',
  Report = '/relatorio/:invoiceId',
  ConsumerUnits = '/unidades-consumidoras',
  AddConsumerUnit = '/unidades-consumidoras/adicionar',
  Profile = '/perfil',
  ConsumerUnit = '/unidades-consumidoras/:consumerUnitId',
  UpdateEnergyGenerated = 'unidades-consumidoras/atualizar-geracao/:invoiceId',
  Help = '/ajuda',
  Inverters = '/inversores',
  Monitorings = '/meus-monitoramentos',
  Account = '/conta',
  Team = '/equipe',
  AcceptTeamInvitation = '/convite-equipe',
  AccountSetup = '/ativar-conta',
  Analises = '/analises',
  ServicosAdicionais = '/servicos-adicionais',
  OportunidadesEconomia = '/oportunidades-economia',
}
